import styled from "styled-components";
import { palette } from "styled-theme";

const BranchesListWrapper = styled.div`
  .listItem {
    padding: 20px;
    border-radius: 20px;
    background-color: ${palette("surfaceColor", 0)};
    border: 1px solid ${palette("border", 0)};
    cursor: pointer;
    &:hover {
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.16) !important;
    }
  }
  .fieldContainer {
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    h3 {
      margin-bottom: 20px;
    }
    .ant-typography {
      padding: 0 10px;
    }
    .ant-avatar-lg.ant-avatar-icon {
      background: rgb(215, 218, 223);
      span {
        color: rgba(0, 0, 0, 0.85);
        height: 100%;
        font-size: 16px;
        align-items: center;
        justify-content: center;
        display: flex;
      }
    }
  }
`;

export default BranchesListWrapper;
